var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Model, Inject } from 'vue-property-decorator';
import { INJECT_UICORE_DESIGNER } from "../../../../../../lib/utils/consts";
import { StyleSheetEditModal } from "../../../../../../lib/comps/PropPanel/StylePanel/comps/StyleTemplate/StyleSheetEditModal";
import * as styles from "./index.module.css";
import UcWindow from "../../../../../../lib/UcWindow";
import Portal from "../../../../../../lib/comps/Portal/Portal";
import { clamp, mapValues } from "lodash-es";
const stopPropagation = ev => {
  ev.cancelBubble = true;
  ev.stopPropagation();
};
/** 编辑/删除/启用/禁用StyleSheet */
let StyleSheetManageModal = class StyleSheetManageModal extends Vue {
  constructor() {
    super(...arguments);
    this.showAppliedOnly = false;
    this.selectedRowKeys = [];
  }
  get stylePanelState() {
    return this.designer.stylePanelState;
  }
  get allStyleSheet() {
    return this.stylePanelState.styleSheetList;
  }
  get activeStyleSheet() {
    return this.stylePanelState.currentActiveStyleSheetList;
  }
  created() {
    if (this.tableDataSource.length > 0) {
      this.selectedRowKeys = [this.tableDataSource[0].id];
    }
  }
  mounted() {
    this.$nextTick(() => {
      // open modal要用$ref 等1tick
      this.$watch('selectedRowKeys', newVal => {
        if (newVal.length === 0) return;
        this.openEditModal(newVal[0]);
      }, {
        immediate: true,
        deep: true
      });
    });
  }
  close() {
    this.$emit('change', false);
  }
  openEditModal(id) {
    const sheet = this.allStyleSheet.find(item => item.id === id);
    this.$refs.editModal.open(sheet);
  }
  async unMountStyle(styleSheet) {
    await this.stylePanelState.unMountStyleSheet(styleSheet.id);
  }
  async mountStyle(styleSheet) {
    await this.stylePanelState.mountStyleSheet(styleSheet.id);
  }
  deleteStyle(styleSheet) {
    this.stylePanelState.deleteStyleSheet(styleSheet);
    this.selectedRowKeys = [];
  }
  get tableDataSource() {
    const dataSourceSheets = this.showAppliedOnly ? this.activeStyleSheet : this.allStyleSheet;
    const dataSourceMaped = dataSourceSheets.map(item => {
      const isApplied = !!this.activeStyleSheet.find(activeItem => activeItem.id === item.id);
      return {
        ...item,
        isApplied
      };
    });
    return dataSourceMaped;
  }
  renderOperation(data, record) {
    const h = this.$createElement;
    return h("div", {
      "style": 'width: fit-content;',
      "on": {
        "click": stopPropagation
      }
    }, [h("a-popconfirm", {
      "attrs": {
        "title": "确定删除这个模板吗?",
        "ok-text": "是",
        "cancel-text": "否"
      },
      "on": {
        "confirm": () => this.deleteStyle(record)
      }
    }, [h("a", {
      "class": "uc-style-link"
    }, ["\u5220\u9664"])])]);
  }
  get tableColumns() {
    const h = this.$createElement;
    const tableColumn = [{
      title: '模板名',
      dataIndex: 'name',
      key: 'name'
    }, {
      title: '是否启用',
      key: 'apply',
      customRender: (data, record) => h("div", {
        "style": 'width: fit-content;',
        "on": {
          "click": stopPropagation
        }
      }, [h("a-switch", {
        "attrs": {
          "checked": record.isApplied
        },
        "on": {
          "change": ev => ev ? this.mountStyle(record) : this.unMountStyle(record)
        }
      })])
    }, {
      title: '操作',
      key: 'action',
      customRender: this.renderOperation
    }];
    return tableColumn;
  }
  get customRow() {
    return record => ({
      on: {
        click: () => {
          this.selectedRowKeys = [record.id];
        } // 点击行
      }
    });
  }
  renderEditModal() {
    const h = this.$createElement;
    const vNodes = [];
    const emptySelect = this.selectedRowKeys.length === 0;
    vNodes.push(h(StyleSheetEditModal, {
      "style": emptySelect ? 'display:none' : '',
      "class": styles.manageModalEdit,
      "attrs": {
        "modalMode": "div",
        "isCreateNew": false
      },
      "ref": "editModal"
    }));
    if (emptySelect) {
      vNodes.push(h("div", {
        "class": styles.manageModalEmptyEditPlaceholder
      }, [h("a-alert", {
        "attrs": {
          "message": "请在从左侧选择样式模板进行编辑",
          "type": "info"
        }
      })]));
    }
    return vNodes;
  }
  renderModalContext() {
    const h = this.$createElement;
    return h("div", [h("div", {
      "style": "margin-bottom: 10px;"
    }, [h("a-checkbox", {
      "model": {
        value: this.showAppliedOnly,
        callback: $$v => {
          this.showAppliedOnly = $$v;
        }
      }
    }, ["\u53EA\u770B\u5F53\u524D\u7EC4\u4EF6\u542F\u7528\u7684\u6A21\u677F"])]), h("div", {
      "class": styles.manageModalContext
    }, [h("a-table", {
      "class": styles.manageModalTable,
      "attrs": {
        "rowKey": "id",
        "columns": this.tableColumns,
        "data-source": this.tableDataSource,
        "pagination": {
          pageSize: 10
        },
        "customRow": this.customRow,
        "row-selection": {
          selectedRowKeys: this.selectedRowKeys
        }
      }
    }), this.renderEditModal()])]);
  }
  ucSize() {
    const width = clamp(window.innerWidth - 200, 600, 1000);
    const left = clamp((window.innerWidth - width) / 2, 0, 2000);
    const top = window.innerHeight * 0.25;
    return mapValues({
      width,
      left,
      top
    }, value => `${value}px`);
  }
  render() {
    const h = arguments[0];
    return h("div", [h(Portal, {
      "attrs": {
        "target": "window"
      }
    }, [h("uc-window", {
      "attrs": {
        "left": this.ucSize().left,
        "top": this.ucSize().top,
        "width": this.ucSize().width,
        "title": "样式模板管理",
        "visible": this.modalVisible
      },
      "on": {
        "close": this.close
      }
    }, [this.renderModalContext()])])]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER,
  default: null
})], StyleSheetManageModal.prototype, "designer", void 0);
__decorate([Model('change', {
  type: Boolean,
  required: true
})], StyleSheetManageModal.prototype, "modalVisible", void 0);
StyleSheetManageModal = __decorate([Component({
  name: 'StyleSheetManageModal',
  components: {
    UcWindow,
    Portal
  }
})], StyleSheetManageModal);
export { StyleSheetManageModal };
//# sourceMappingURL=StyleSheetManageModal.js.map
